// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { nativeScrollViewProps } from 'components/common/scroll/TreactNativeScrollStyles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/treactui-template/organisms/page/PageContent';
import useVersionsApi from './versions/useVersionsApi';
import { Table } from '@tls/treact-ui';
import TestableLoader from 'components/treactui-template/atoms/TestableLoader';

export default function Versions() {
  const { t } = useTranslation();
  const { loadingVersions, versions } = useVersionsApi();

  return (
    <PageContent displayAsPaper disableScroll>
      <Table>
        <Table.Header>
          <Table.HeaderRow>
            <Table.HeaderCell width='50%'>{t('settings.versions.name')}</Table.HeaderCell>
            <Table.HeaderCell width='50%'>{t('settings.versions.version')}</Table.HeaderCell>
          </Table.HeaderRow>
        </Table.Header>
        <Table.ScrollingBody scrollViewProps={nativeScrollViewProps}>
          {loadingVersions && <TestableLoader label='' data-testid='settings-versions-loader' />}
          {versions?.map(version => (
            <Table.Row key={version.name} data-testid={`settings-version-${version.name}-row`}>
              <Table.Cell width='50%'>{version.name}</Table.Cell>
              <Table.Cell width='50%'>{version.version}</Table.Cell>
            </Table.Row>
          ))}
        </Table.ScrollingBody>
      </Table>
    </PageContent>
  );
}
